import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { PureComponent, createElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import { isolateMixin, ifMobile } from '../utils/mixins';

var getFontStyle = function getFontStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 400 : _ref$fontWeight,
      lineHeight = _ref.lineHeight,
      mobile = _ref.mobile,
      style = _objectWithoutProperties(_ref, ["fontWeight", "lineHeight", "mobile"]);

  return _extends({}, style, {
    fontWeight: fontWeight,
    lineHeight: lineHeight && lineHeight + 'px'
  });
};

var styles = function styles(_ref2) {
  var typography = _ref2.typography;
  return {
    reset: isolateMixin,
    h1: _extends({
      extend: getFontStyle(typography.h1),
      margin: '15px 0'
    }, ifMobile({
      extend: getFontStyle(typography.h1.mobile)
    })),
    h2: _extends({
      extend: getFontStyle(typography.h2),
      margin: '20px 0'
    }, ifMobile({
      extend: getFontStyle(typography.h2.mobile)
    })),
    h3: _extends({
      extend: getFontStyle(typography.h3),
      margin: '20px 0'
    }, ifMobile({
      extend: getFontStyle(typography.h3.mobile)
    })),
    text: _extends({
      extend: getFontStyle(typography.text),
      margin: '20px 0'
    }, ifMobile({
      extend: getFontStyle(typography.text.mobile)
    })),
    quote: {
      extend: getFontStyle(typography.quote),
      margin: '30px 0',
      paddingLeft: 37,
      borderLeft: "3px solid ".concat(typography.quote.borderColor),
      '& p': {
        margin: 0
      },
      '& p + p': {
        marginTop: 20
      }
    },
    epigraph: {
      extend: getFontStyle(typography.epigraph),
      margin: '20px 0'
    },
    source: {
      composes: '$uppercase',
      extend: getFontStyle(typography.source)
    },
    timestamp: {
      extend: getFontStyle(typography.timestamp)
    },
    description: {
      extend: getFontStyle(typography.description),
      margin: '20px 0 25px'
    },
    galleryDescription: {
      extend: getFontStyle(typography.galleryDescription)
    },
    photoSource: {
      extend: getFontStyle(typography.photoSource)
    },
    list: {
      extend: getFontStyle(typography.text),
      position: 'relative',
      margin: '30px 0',
      paddingLeft: 40,
      listStyle: 'none',
      '& li + li': {
        marginTop: 15
      },
      '& li:before': {
        position: 'absolute',
        left: 0
      },
      'ul& li:before': {
        content: '""',
        marginTop: 9,
        width: 10,
        height: 10,
        borderRadius: '50%',
        background: typography.list.bullet.color
      },
      'ol&': {
        counterReset: 'order'
      },
      'ol& li:before': {
        extend: getFontStyle(typography.list.number),
        counterIncrement: 'order',
        content: 'counter(order)"."',
        color: typography.list.number.color
      }
    },
    uppercase: {
      textTransform: 'uppercase',
      letterSpacing: 1.3 / 11 + 'em'
    }
  };
};

var Typography = /*#__PURE__*/function (_PureComponent) {
  _inherits(Typography, _PureComponent);

  var _super = _createSuper(Typography);

  function Typography() {
    _classCallCheck(this, Typography);

    return _super.apply(this, arguments);
  }

  _createClass(Typography, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tagName = _this$props.tagName,
          className = _this$props.className,
          classes = _this$props.classes,
          type = _this$props.type,
          uppercase = _this$props.uppercase,
          children = _this$props.children,
          theme = _this$props.theme,
          other = _objectWithoutProperties(_this$props, ["tagName", "className", "classes", "type", "uppercase", "children", "theme"]);

      return createElement(tagName, _extends({
        className: classnames(className, classes.reset, type && classes[type], uppercase && classes.uppercase)
      }, other), children);
    }
  }]);

  return Typography;
}(PureComponent);

Typography.defaultProps = {
  tagName: 'div'
};
Typography.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Тип элемента
   */
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'text', 'quote', 'epigraph', 'source', 'timestamp', 'description', 'galleryDescription', 'photoSource', 'list']),

  /**
   * Имя тега
   */
  tagName: PropTypes.string,

  /**
   * Содержимое элемента
   */
  children: PropTypes.node,

  /**
   * Заглавные буквы
   */
  uppercase: PropTypes.bool
} : {};
export default withStyles(styles, {
  name: 'Typography'
})(Typography);